type Props = {
  children: React.ReactChild;
  size: 'small' | 'medium' | 'large';
  theme: 'light' | 'dark' | 'blue';
  onClose: () => void;
  showBackButton?: boolean;
  showCloseButton?: boolean;
};

const Card = ({ children, size, theme, showBackButton, showCloseButton = true, onClose }: Props) => {
  const cardWidth =
    size === 'small'
      ? 'w-[360px] pb-8 pt-5 px-4 sm:w-full'
      : size === 'medium'
      ? 'w-[554px] sm:w-full'
      : 'max-w-[683px] md:w-full md:h-auto';
  const cardBg = theme === 'light' ? 'bg-main-grey-200' : theme === 'dark' ? 'bg-black' : 'bg-main-blue';

  return (
    <div className={`${cardWidth} ${cardBg} rounded-3xl relative`}>
      {showBackButton && (
        <div
          className={`absolute
            cursor-pointer
            w-[32px] 
            h-[32px] 
            top-[16px] 
            left-[16px] 
            rounded-full 
            bg-main-grey-300 
            flex 
            items-center 
            justify-center
            z-10`}
        >
          <svg xmlns='http://www.w3.org/2000/svg' width='16' height='13' viewBox='0 0 16 13' fill='none'>
            <path
              // eslint-disable-next-line max-len
              d='M0.867676 6.68994C0.867676 6.97559 0.992188 7.27588 1.18994 7.47363L5.96533 12.2344C6.18506 12.4541 6.44873 12.564 6.70508 12.564C7.32764 12.564 7.75244 12.1318 7.75244 11.5605C7.75244 11.2456 7.61328 10.9893 7.41553 10.7988L5.7749 9.1582L4.14893 7.66406L5.75293 7.75195H14.0293C14.6885 7.75195 15.1279 7.31982 15.1279 6.68994C15.1279 6.05273 14.6885 5.62793 14.0293 5.62793H5.75293L4.15625 5.71582L5.7749 4.22168L7.41553 2.57373C7.61328 2.3833 7.75244 2.13428 7.75244 1.81201C7.75244 1.24072 7.32764 0.808594 6.70508 0.808594C6.44873 0.808594 6.18506 0.918457 5.95801 1.14551L1.18994 5.90625C0.992188 6.104 0.867676 6.4043 0.867676 6.68994Z'
              fill='black'
            />
          </svg>
        </div>
      )}

      {showCloseButton && (
        <div
          className={`absolute
        cursor-pointer
        w-[32px] 
        h-[32px] 
        top-[16px] 
        right-[16px] 
        rounded-full 
        bg-main-grey-300 
        flex 
        items-center 
        justify-center
        z-10`}
          onClick={onClose}
          onKeyDown={onClose}
          tabIndex={0}
          style={{ outline: 'none' }}
          role='button'
        >
          <svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14' fill='none'>
            <rect
              x='1.66699'
              y='3.44446'
              width='2.4'
              height='12.5708'
              transform='rotate(-45 1.66699 3.44446)'
              fill='black'
            />
            <rect
              width='2.4'
              height='12.5708'
              transform='matrix(-0.707107 -0.707107 -0.707107 0.707107 12.3335 3.44446)'
              fill='black'
            />
          </svg>
        </div>
      )}

      {children}
    </div>
  );
};

export { Card };
